var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPremium = function SvgPremium(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 47.25 51.73"
  }, props), _defs || (_defs = React.createElement("defs", null, React.createElement("linearGradient", {
    id: "premium_svg__linear-gradient",
    x1: 604.47,
    y1: 73.22,
    x2: 603.76,
    y2: 100.29,
    gradientTransform: "rotate(41.33 390.164 -724.252)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#33bcc7"
  })), React.createElement("linearGradient", {
    id: "premium_svg__linear-gradient-2",
    x1: 604.11,
    y1: 74.29,
    x2: 604.24,
    y2: 90.97,
    gradientTransform: "rotate(41.33 390.164 -724.252)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#e1eff8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#33bcc7"
  })), React.createElement("linearGradient", {
    id: "premium_svg__linear-gradient-3",
    x1: 4.95,
    y1: 38.48,
    x2: 4.48,
    y2: 56.02,
    gradientTransform: "rotate(-90 11.345 24.575)",
    xlinkHref: "#premium_svg__linear-gradient"
  }), React.createElement("linearGradient", {
    id: "premium_svg__linear-gradient-4",
    x1: -12.45,
    y1: 4.16,
    x2: -12.36,
    y2: 14.4,
    gradientTransform: "rotate(-93.67 19.732 -.236)",
    xlinkHref: "#premium_svg__linear-gradient-2"
  }), React.createElement("radialGradient", {
    id: "premium_svg__radial-gradient",
    cx: 75.87,
    cy: 72.43,
    r: 149.17,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.32,
    stopColor: "#00283d"
  }), React.createElement("stop", {
    offset: 0.35,
    stopColor: "#043145"
  }), React.createElement("stop", {
    offset: 0.52,
    stopColor: "#246c7c"
  }), React.createElement("stop", {
    offset: 0.67,
    stopColor: "#3c9ca8"
  }), React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4ebec8"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#59d2db"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#5ddae2"
  })), React.createElement("radialGradient", {
    id: "premium_svg__radial-gradient-2",
    cx: 1.32,
    cy: 21.37,
    r: 37.97,
    gradientTransform: "rotate(-93.67 19.732 -.236)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.32,
    stopColor: "#30d5c9"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3993df"
  })), React.createElement("style", null, ".premium_svg__cls-5{opacity:.95}"))), _g || (_g = React.createElement("g", {
    id: "premium_svg__Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "premium_svg__Logos"
  }, React.createElement("path", {
    d: "M23.63 50.73a8.2 8.2 0 01-4.05-1.07l-7.18-4.14-6.26-3.63-1.09-.62a8.14 8.14 0 01-4-7V17.48a8.09 8.09 0 014.05-7l14.48-8.39a8.07 8.07 0 018.1 0l14.52 8.38a8.13 8.13 0 014 7v16.78a8.18 8.18 0 01-4 7l-14.52 8.4a8.16 8.16 0 01-4.05 1.08z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M23.63 50.73a8.2 8.2 0 01-4.05-1.07l-7.18-4.14-6.26-3.63-1.09-.62a8.14 8.14 0 01-4-7V17.48a8.09 8.09 0 014.05-7l14.48-8.39a8.07 8.07 0 018.1 0l14.52 8.38a8.13 8.13 0 014 7v16.78a8.18 8.18 0 01-4 7l-14.52 8.4a8.16 8.16 0 01-4.05 1.08z",
    fill: "url(#premium_svg__radial-gradient)"
  }), React.createElement("path", {
    d: "M23.63 2a7.07 7.07 0 013.55 1l14.52 8.34a7.09 7.09 0 013.55 6.14v16.77a7.15 7.15 0 01-3.55 6.16l-14.52 8.38a7.17 7.17 0 01-7.1 0l-7.18-4.14L6.64 41l-1.09-.62A7.13 7.13 0 012 34.25V17.48a7.06 7.06 0 013.55-6.14L20.08 3a7 7 0 013.55-1m0-2a9.15 9.15 0 00-4.56 1.23L4.55 9.61A9.09 9.09 0 000 17.48v16.77a9.16 9.16 0 004.55 7.89l1.09.62 6.26 3.62 7.18 4.14a9.14 9.14 0 009.09 0l14.53-8.38a9.19 9.19 0 004.55-7.89V17.48a9.11 9.11 0 00-4.55-7.87L28.18 1.23A9.11 9.11 0 0023.63 0z",
    fill: "#b9e8ee"
  }), React.createElement("path", {
    d: "M13.84 22.13c.94-1.64.31-9.1.31-9.1s3.24 6.76 4.86 7.69 9.1.3 9.1.3-6.85 3.42-7.69 4.87-.31 9.1-.31 9.1-3.42-6.86-4.92-7.72-9-.28-9-.28 6.72-3.24 7.65-4.86z",
    fill: "url(#premium_svg__linear-gradient)"
  }), React.createElement("path", {
    d: "M14.15 13s3.24 6.76 4.86 7.69 9.1.3 9.1.3-6.85 3.42-7.69 4.87-.31 9.1-.31 9.1z",
    fill: "url(#premium_svg__linear-gradient-2)"
  }), React.createElement("path", {
    d: "M32.93 33.39c-1.12.35-4 3.93-4 3.93S30.33 33 30 31.83s-3.93-4-3.93-4 4.5 1.41 5.5 1.11 4-3.93 4-3.93-1.39 4.5-1.09 5.53 3.91 4 3.91 4-4.39-1.47-5.46-1.15z",
    fill: "url(#premium_svg__radial-gradient-2)"
  }), React.createElement("path", {
    d: "M32.93 33.39c-1.12.35-4 3.93-4 3.93S30.33 33 30 31.83s-3.93-4-3.93-4 4.5 1.41 5.5 1.11 4-3.93 4-3.93-1.39 4.5-1.09 5.53 3.91 4 3.91 4-4.39-1.47-5.46-1.15z",
    fill: "url(#premium_svg__linear-gradient-3)"
  }), React.createElement("path", {
    d: "M28.91 37.32S30.33 33 30 31.83s-3.93-4-3.93-4 4.5 1.41 5.5 1.11 4-3.93 4-3.93z",
    fill: "url(#premium_svg__linear-gradient-4)"
  })))));
};
export default __webpack_public_path__ + "108ba4a541fa4fcca08674274ecbbfd0.svg";
export { SvgPremium as ReactComponent };